import React from 'react'
import { CustomerInfoView } from '../code/enums/Enums';
import Customer from '../code/models/Customer'
import CustomerInfoBiddingPlans from './CustomerInfoBiddingPlans';
import CustomerInfoDetail from './CustomerInfoDetail';
import CustomerInfoBillingInfo from './CustomerInfoBillingInfo';
import CustomerInfoProfiles from './CustomerInfoProfiles';
import CustomerInfoTabControl from './CustomerInfoTabControl'
import AuthAdminUserModel from '../code/models/AuthAdminUserModel';
import CustomerSubscriptionInfo from "./CustomerSubscriptionInfo";
import CustomerInfoPilot from "./CustomerInfoPilot";
import CustomerInfoAwardReport from "./CustomerInfoAwardReport";

interface ICustomerInfoForm {
  customer: Customer;
  currentUser: AuthAdminUserModel;
  showToast: (message: string) => void;
  customerDeleted: Function;
}

export default function CustomerInfoForm({ customer, currentUser, showToast, customerDeleted }: ICustomerInfoForm) {
  const [selectedView, setSelectedView] = React.useState<CustomerInfoView>(CustomerInfoView.CustomerInfo);

  function onSelectedViewChange(view: CustomerInfoView) {
    setSelectedView(view);
  }

  return (
    <React.Fragment>
      <CustomerInfoTabControl selectedView={selectedView} selectedViewChange={onSelectedViewChange} />
      {selectedView === CustomerInfoView.CustomerInfo && <CustomerInfoDetail customer={customer} currentUser={currentUser} customerDeleted={customerDeleted}/>}
      {selectedView === CustomerInfoView.SubscriptionInfo && <CustomerSubscriptionInfo customer={customer} currentUser={currentUser} />}
      {selectedView === CustomerInfoView.PaymentInfo && <CustomerInfoBillingInfo customer={customer} currentUser={currentUser} showToast={showToast} />}
      {selectedView === CustomerInfoView.Profiles && <CustomerInfoProfiles customerId={customer.customerId} />}
      {selectedView === CustomerInfoView.BiddingPlans && <CustomerInfoBiddingPlans currentUser={currentUser} customer={customer} />}
      {selectedView === CustomerInfoView.PilotInfo && <CustomerInfoPilot customer={customer} currentUser={currentUser} />}
      {selectedView === CustomerInfoView.AwardReport && <CustomerInfoAwardReport customer={customer} currentUser={currentUser} />}
    </React.Fragment>
  )
}
